import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocatorMainComponent } from './locator-main.component';
import { LocationServicesComponent } from './location-services/location-services/location-services.component';
import { LocationSearchResultComponent } from './location-search-result/location-search-result/location-search-result.component';
import { DemoMaterialModule } from '../material.module';
import { DialogComponent } from '../shared/dialog/dialog.component';
import { BaseComponent } from '../shared/base.component';
import { MapService } from '../services/map.service';
import { LocationSearchDetailComponent } from './location-search-detail/location-search-detail/location-search-detail.component';
import { LocationSearchComponent } from './location-search/location-search/location-search.component';
import { LocationMapComponent } from './location-map/location-map/location-map.component';
import { LocationClosingHourComponent } from './location-closing-hour/location-closing-hour.component';
import { OurFormsModule } from '../forms/forms.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { GooglePlaceModule } from 'ngx-google-places-autocomplete'; TODO:  Remove this if autocomplete works and we dont this library

const LOCATOR_COMPONENTS = [
  LocatorMainComponent,
  LocationServicesComponent,
  LocationSearchResultComponent,
  LocationSearchDetailComponent,
  LocationSearchComponent,
  LocationMapComponent,
  LocationClosingHourComponent
];

@NgModule({
  declarations: [LOCATOR_COMPONENTS],
  imports: [
    CommonModule,
    DemoMaterialModule,
    OurFormsModule,
    ReactiveFormsModule,
    FormsModule,
    // GooglePlaceModule, TODO: Remove this if autocomplete works and we dont this library
  ],
  exports: [LOCATOR_COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [BaseComponent, MapService],
  // entryComponents: [],
})
export class LocatorModule {}
